import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["slide", "container", "previousButton", "nextButton"];

  connect() {
    this.currentIndex = 0;
    this.handleScroll = this.handleScroll.bind(this);
    this.scrollContainer = this.hasContainerTarget
      ? this.containerTarget
      : this.element.querySelector(".snap-x");
    this.scrollContainer.addEventListener("scroll", this.handleScroll);
    this.updateButtonVisibility();
  }

  disconnect() {
    this.scrollContainer.removeEventListener("scroll", this.handleScroll);
  }

  next(event) {
    event.preventDefault();

    if (this.currentIndex < this.slideTargets.length - 1) {
      this.currentIndex++;
      this.scrollToSlide(this.currentIndex);
      this.updateButtonVisibility();
    }
  }

  previous(event) {
    event.preventDefault();

    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.scrollToSlide(this.currentIndex);
      this.updateButtonVisibility();
    }
  }

  scrollToSlide(index) {
    const slide = this.slideTargets[index];
    if (slide) {
      slide.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start",
      });
    }
  }

  handleScroll() {
    // Debounce the scroll event
    clearTimeout(this.scrollTimeout);
    this.scrollTimeout = setTimeout(() => {
      this.updateCurrentIndex();
    }, 150);
  }

  updateCurrentIndex() {
    const scrollLeft = this.scrollContainer.scrollLeft;
    const containerWidth = this.scrollContainer.offsetWidth;

    // Find which slide is most visible
    let closestIndex = 0;
    let closestDistance = Infinity;

    this.slideTargets.forEach((slide, index) => {
      const slideLeft = slide.offsetLeft;
      const distance = Math.abs(scrollLeft - slideLeft);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    this.currentIndex = closestIndex;
    this.updateButtonVisibility();
  }

  updateButtonVisibility() {
    // Show/hide previous button
    if (this.hasPreviousButtonTarget) {
      if (this.currentIndex === 0) {
        this.previousButtonTarget.classList.add(
          "opacity-0",
          "pointer-events-none",
        );
        this.previousButtonTarget.classList.remove("opacity-100");
      } else {
        this.previousButtonTarget.classList.remove(
          "opacity-0",
          "pointer-events-none",
        );
        this.previousButtonTarget.classList.add("opacity-100");
      }
    }

    // Show/hide next button
    if (this.hasNextButtonTarget) {
      if (this.currentIndex === this.slideTargets.length - 1) {
        this.nextButtonTarget.classList.add("opacity-0", "pointer-events-none");
        this.nextButtonTarget.classList.remove("opacity-100");
      } else {
        this.nextButtonTarget.classList.remove(
          "opacity-0",
          "pointer-events-none",
        );
        this.nextButtonTarget.classList.add("opacity-100");
      }
    }
  }
}
